import axios from 'axios'

const CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

export const queryStringToJSON = function () {
  var pairs = location.search.slice(1).split('&')
  var result = {}
  pairs.forEach(function (pair) {
    pair = pair.split('=')
    result[pair[0]] = decodeURIComponent(pair[1] || '')
  })
  return JSON.parse(JSON.stringify(result))
}

export const getADCode = function () {
  let url = window.location.href
  if (url && url.includes('code') && url.includes('state')) {
    let splits = url.split('?')
    let authCodeSplit = splits[1]
    let endOfAuthCode = authCodeSplit.split('#/')
    return queryStringToJSON(endOfAuthCode)
  }
}

export const makeid = function (length) {
  let result = ''
  let charactersLength = CHARACTERS.length
  for (var i = 0; i < length; i++) {
    result += CHARACTERS.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

export const passPruneInspection = function (str = '') {
  let numberOfPercents = str.split('%').length - 1
  let newString = str.replace(/ /g, '-').replace(/[?”"/'’>.<,;:{[}\]+=()*&^%$#@!~`]/g, '')
  let prunedNumOfPercents = encodeURI(newString).split('%').length - 1
  if (prunedNumOfPercents > numberOfPercents) {
    return false
  } else {
    return true
  }
}

export const getAllDatasetsRootFamilyFromQuery = function (query) {
  const dataSetsRootFamilies = new Set()
  for (let el of query) {
    if (Array.isArray(el)) {
      let dtsFamily = getAllDatasetsRootFamilyFromQuery(el)
      for (let df of dtsFamily) {
        dataSetsRootFamilies.add(df)
      }
    } else if (typeof el === 'string') {
      // ignore
    } else {
      // it is an object
      dataSetsRootFamilies.add(el.rootFamily)
    }
  }
  return Array.from(dataSetsRootFamilies)
}



// WEBPACK FOOTER //
// ./src/app/common/U.js